import React, {Component} from 'react'
import {connect} from 'react-redux'
import {api} from "../../../../api";
import RaisedButton from 'material-ui/RaisedButton';
import * as SnackbarActions from "../../../../api/snackbar/actions";
import FontAwesome from 'react-fontawesome';
import Collapsible from 'react-collapsible';

class AppSettingsSidebarWidgetsComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			settings   : {
				leadCollector: {
					title    : 'Abonneer je op __TITLE__',
					intro    : 'Schrijf je in voor onze alerts en ontvang een e-mail wanneer er een artikel over __TITLE__ wordt gepubliceerd.',
					button   : 'Abonneren',
					textBelow: '27.756 abonnees | <a href="https://www.google.com">Bekijk voorbeeld</a>',
				},
				featuredArticle: {
					title    : 'Lees ook',
				},
				taggedArticles: {
					title: 'Meer over __TITLE__',
				},
				jobs: {
					title: '__TITLE__ vacatures',
				},
				downloads: {
					title: '__TITLE__ downloads',
				},
				recentPosts: {
					title: 'Ook op Frankwatching',
				},
			},
			initialized: false
		};

		this.changeInputValue = this.changeInputValue.bind(this);
		this.saveSettings = this.saveSettings.bind(this);
		this.loadSettings = this.loadSettings.bind(this);
	}

	componentDidMount() {
		this.loadSettings();
	}

	loadSettings() {
		api.settings.sidebarWidgets.getSettings().then(response => {
			console.log( response.val() );

			const sections = Object.keys( response.val() );

			for ( const section of sections ) {
				const fields = Object.keys( response.val()[section] );

				for ( const field of fields ) {
					this.setState({
						...this.state,
						settings: {
							...this.state.settings,
							[section]: {
								...this.state.settings[section],
								[field]: response.val()[section][field]
							}
						}
					})
				}
			}

			// for ( const section of response.val() ) {
			// 	console.log( section );
			// }

			// if (null !== response.val()) {
			// 	this.setState({
			// 		settings: response.val()
			// 	});
			// }
		});
	}

	changeInputValue = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		const [section, inputName] = name.split('__');

		this.setState({
			settings: {
				...this.state.settings,
				[section]: {
					...this.state.settings[section],
					[inputName]: value
				}
			}
		});
	};

	saveSettings() {
		api.settings.sidebarWidgets.saveSettings(this.state.settings).then(() => {
			api.snackbar.showMessage('De instellingen zijn opgeslagen');
		})
	}

	render() {
		return (
			<div className="medium-12 cell">
				<div className="grid-x grid-container grid-padding-x">
					<div className="small-12 cell">
						<h2>Kantlijn widget instellingen</h2>
					</div>
					<div className="small-12 cell">
						<Collapsible trigger="Leadcollector" transitionTime={200}>
							<div className="grid-x grid-padding-x">
								<fieldset className="large-12 cell">
									<p>Hieronder kan je de standaard teksten instellen wanneer er een generieke leadcollector widget wordt gebruiikt. Je kunt de merge tag __TITLE__ gebruiken om de titel van het hoofdtopic weer te geven in deze widget.</p>
									<label>
										Titel
										<input type="text" name={'leadCollector__title'} onChange={this.changeInputValue} value={this.state.settings.leadCollector.title} />
									</label>
									<label>
										Intro
										<textarea name={'leadCollector__intro'} onChange={this.changeInputValue} value={this.state.settings.leadCollector.intro} />
									</label>
									<label>
										Button tekst
										<input type="text" name={'leadCollector__button'} onChange={this.changeInputValue} value={this.state.settings.leadCollector.button} />
									</label>
									<label>
										Tekst onder formulier
										<textarea name={'leadCollector__textBelow'} onChange={this.changeInputValue} value={this.state.settings.leadCollector.textBelow} />
									</label>
								</fieldset>
							</div>
						</Collapsible>
						<Collapsible trigger="Aanbevolen artikel" transitionTime={200}>
							<div className="grid-x grid-padding-x">
								<fieldset className="large-12 cell">
									<label>
										Boventekst
										<input type="text" name={'featuredArticle__title'} onChange={this.changeInputValue} value={this.state.settings.featuredArticle.title} />
									</label>
								</fieldset>
							</div>
						</Collapsible>
						<Collapsible trigger="Topic artikelen" transitionTime={200}>
							<div className="grid-x grid-padding-x">
								<fieldset className="large-12 cell">
									<label>
										Titel
										<input type="text" name={'taggedArticles__title'} onChange={this.changeInputValue} value={this.state.settings.taggedArticles.title} />
									</label>
								</fieldset>
							</div>
						</Collapsible>
						<Collapsible trigger="Topic vacatures" transitionTime={200}>
							<div className="grid-x grid-padding-x">
								<fieldset className="large-12 cell">
									<label>
										Titel
										<input type="text" name={'jobs__title'} onChange={this.changeInputValue} value={this.state.settings.jobs.title} />
									</label>
								</fieldset>
							</div>
						</Collapsible>
						<Collapsible trigger="Topic downloads" transitionTime={200}>
							<div className="grid-x grid-padding-x">
								<fieldset className="large-12 cell">
									<label>
										Titel
										<input type="text" name={'downloads__title'} onChange={this.changeInputValue} value={this.state.settings.downloads.title} />
									</label>
								</fieldset>
							</div>
						</Collapsible>
						<Collapsible trigger="Recente artikelen" transitionTime={200}>
							<div className="grid-x grid-padding-x">
								<fieldset className="large-12 cell">
									<label>
										Titel
										<input type="text" name={'recentPosts__title'} onChange={this.changeInputValue} value={this.state.settings.recentPosts.title} />
									</label>
								</fieldset>
							</div>
						</Collapsible>
					</div>

				</div>
				<div className="settings--content--spacer"></div>
				<div className="grid-x grid-container grid-padding-y">
					<div className="small-12 cell text-right">
						<RaisedButton
							label="Instellingen Opslaan"
							primary={true}
							onClick={this.saveSettings}
							fullWidth={true}
						/>
					</div>
				</div>

			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.auth.user
	}
};

export default connect(mapStateToProps)(AppSettingsSidebarWidgetsComponent)


// WEBPACK FOOTER //
// ./src/application/components/settings/sidebar-widgets/index.js